'use client';
import { useRef, useState, useEffect } from 'react';
import { FormControl } from 'react-bootstrap';
import { ChevronDown, Check } from 'react-feather';
import { useRouter, usePathname } from 'next/navigation';
import classes from './FilterComps.module.css';

const PriceFilter = (props) => {
	const { theMinPrice, theMaxPrice } = props;

	const router = useRouter();
	const pathname = usePathname();

	const [showPricing, setShowPricing] = useState();

	useEffect(() => {
		setShowPricing(
			window.innerWidth > 600 || theMaxPrice || theMinPrice ? true : false
		);
	}, [theMaxPrice, theMinPrice]);

	const maxInputRef = useRef();
	const minInputRef = useRef();
	const prices = [
		{ id: 'under $500', minPrice: '0', maxPrice: '500' },
		{ id: '$500 to $1000', minPrice: '500', maxPrice: '1000' },
		{ id: '$1000 to $1500', minPrice: '1000', maxPrice: '1500' },
		{ id: '$1500 and up', minPrice: '1500', maxPrice: '' },
	];

	const showPricingHandler = () => {
		setShowPricing(!showPricing);
	};

	const setPriceHandler = () => {
		let newParams = new URLSearchParams(window.location.search);

		newParams.delete('minPrice');
		newParams.delete('maxPrice');
		if (maxInputRef.current.value) {
			newParams.append('maxPrice', maxInputRef.current.value);
		}
		if (minInputRef.current.value) {
			newParams.append('minPrice', minInputRef.current.value);
		}
		router.replace(pathname + '?' + newParams);
	};

	const clearPricesHandler = () => {
		let newParams = new URLSearchParams(window.location.search);
		newParams.delete('maxPrice');
		newParams.delete('minPrice');
		router.replace(pathname + '?' + newParams);
		if (maxInputRef.current) {
			maxInputRef.current.value = '';
		}
		if (minInputRef.current) {
			minInputRef.current.value = '';
		}
	};

	const checkBoxHandler = (price) => {
		let newParams = new URLSearchParams(window.location.search);
		newParams.delete('minPrice');
		newParams.delete('maxPrice');
		if (price.maxPrice) {
			newParams.append('maxPrice', price.maxPrice);
		}
		if (price.minPrice) {
			newParams.append('minPrice', price.minPrice);
		}
		router.replace(pathname + '?' + newParams);

		if (maxInputRef.current) {
			maxInputRef.current.value = '';
		}
		if (minInputRef.current) {
			minInputRef.current.value = '';
		}
	};

	return (
		<>
			<div className={classes.desktop}>
				<div className={classes.dropDown}>
					<div onClick={showPricingHandler} className={classes.justifyBetween}>
						Price{' '}
						<ChevronDown
							size={13}
							className={showPricing ? classes.flip : classes.icon}
						/>
					</div>
					{showPricing && (
						<div className={classes.box}>
							{prices.map(({ id, maxPrice, minPrice }, idx) => (
								<div
									key={idx}
									onClick={() => checkBoxHandler({ maxPrice, minPrice })}
									className={classes.checkBoxBox}
								>
									<div className={classes.selectionCheck}>
										<span className={classes.smallGap}>
											<div
												className={
													theMaxPrice === maxPrice && theMinPrice === minPrice
														? classes.checkActive
														: classes.check
												}
											>
												{' '}
												<Check className={classes.checkMark} />
											</div>
											<h3 className={classes.underline}>{id}</h3>
										</span>
									</div>
								</div>
							))}
							<div className={classes.selectionPrices}>
								<div className={classes.priceContainer}>
									<div className={classes.priceInput}>
										<FormControl
											aria-label="Small"
											aria-describedby="inputGroup-sizing-sm"
											ref={minInputRef}
											type="number"
											placeholder="min"
											className={classes.priceInput}
										/>
									</div>
									<div className={classes.dash}>
										<div className={classes.line} />
									</div>
									<div className={classes.priceInput}>
										<FormControl
											aria-label="Small"
											aria-describedby="inputGroup-sizing-sm"
											ref={maxInputRef}
											type="number"
											className={classes.priceInput}
											placeholder="max"
										/>
									</div>
									<div onClick={setPriceHandler} className={classes.apply}>
										Apply
									</div>
								</div>
							</div>
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default PriceFilter;
